import React from 'react';
import {
  Container,
  IntroContentContainer,
  IntroText,
  Title,
} from '@/components/messages/styledComponents';
import MessageInbox from '@/components/messages/MessageInbox';
import useStore from '@/stores/useStore';

const Messages = () => {
  const { isStylist } = useStore();
  return (
    <Container>
      <IntroContentContainer>
        <Title>Messages</Title>
        <IntroText style={{ maxWidth: isStylist ? 'auto' : 280 }}>
          {isStylist
            ? 'Keep the conversation going! Select to view.'
            : 'Your stylist is just a message away'}
        </IntroText>
      </IntroContentContainer>
      <MessageInbox />
    </Container>
  );
};

export default Messages;
